import { render, staticRenderFns } from "./PropostasTribanco.vue?vue&type=template&id=32bc03e0&scoped=true"
import script from "./PropostasTribanco.vue?vue&type=script&lang=js"
export * from "./PropostasTribanco.vue?vue&type=script&lang=js"
import style0 from "./PropostasTribanco.vue?vue&type=style&index=0&id=32bc03e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc03e0",
  null
  
)

export default component.exports